import React from "react";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";

import Button from "components/CustomButtons/Button.jsx";

import PreLoginHeader from "components/Header/PreLoginHeader.jsx";

import Subscriptions from "views/Components/Subscriptions"
import SweetAlert from "react-bootstrap-sweetalert";

import userProfileStyles from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.jsx";
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";

import axios from "axios";

import { getUserGroups } from '../../assets/helpers/utilityHelper.jsx';


import ConditionalWrapper from '../../components/Conditional/conditionalWrapper.jsx';
import { getApiHeaders } from "../../assets/helpers/apiHelper";

import { API_ROOT } from 'api-config';

const style = {
  infoText: {
    fontWeight: "300",
    margin: "10px 0 30px",
    textAlign: "center",
    align: "center"
  },
  proceedButton: {
    marginLeft: "20px"
  },
  icon: {
    color: "#333333",
    margin: "10px auto 0",
    width: "130px",
    height: "130px",
    border: "1px solid #E5E5E5",
    borderRadius: "50%",
    lineHeight: "174px",
    "& svg": {
      width: "55px",
      height: "55px"
    },
    "& .fab,& .fas,& .far,& .fal,& .material-icons": {
      width: "55px",
      fontSize: "55px"
    }
  },
  ...sweetAlertStyle,
  ...userProfileStyles,
  ...regularFormsStyle
};

var userGroups = getUserGroups()

class SubscriptionsPage extends React.Component {

  constructor(props) {
    super(props);
    this._isMounted = false;
    var editByOrg = false
    var viewType = ''
    var cardSubtitle = ''
    var showCardIcon = ''
    var showPreLoginHeaderAndFooter = false
    var useCardWrapper = true
    var showProceedButton = false
    var cardTitle =''
    var waitForEmployerId = false
    if (sessionStorage.getItem('planId') === '') {
      viewType = 'patient'
      cardSubtitle = "choose your subscription"
      showCardIcon = false
      showPreLoginHeaderAndFooter = true
      useCardWrapper = false
      showProceedButton = true
      cardTitle = "Select subscription"
      waitForEmployerId = true
    } else if (userGroups.indexOf('employer') >= 0) {
      viewType = 'employer'
      cardSubtitle = "choose the subscriptions your employees will be able to enroll in"
      showCardIcon = true
      cardTitle = "Select subscriptions"
    }
    this.state = {
      alert: null,
      userId: sessionStorage.getItem('userId'),
      editByOrg: editByOrg,
      viewType: viewType,
      cardSubtitle: cardSubtitle,
      showCardIcon: showCardIcon,
      showPreLoginHeaderAndFooter: showPreLoginHeaderAndFooter,
      useCardWrapper: useCardWrapper,
      showProceedButton: showProceedButton,
      cardTitle: cardTitle,
      selectedPlanId: false,
      employerId: '',
      waitForEmployerId: waitForEmployerId
    }
  }


  componentDidMount() {
    this._isMounted = true;
    //get the employer ID if the user is a patient, as this may determine the plans to display
    if (this.state.viewType === 'patient') {
      axios.get(`${API_ROOT}/parentAccount/?userId=`+sessionStorage.getItem('userId'), {headers: getApiHeaders()})
        .then(res => this.setEmployerId({responseMessage: res.data}));
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  setEmployerId(res) {
    const orgMembers = res.responseMessage
    var org;
    var haveSetOrg = false
    for (org in orgMembers) {
      // if the user is part of an employer group, set the employerId
      if (orgMembers[org].orgType === 'E') {
        this.setState({
          employerId: orgMembers[org].organizationId,
          waitForEmployerId: false
        });
        haveSetOrg = true
        break;
      }
    }
    // if we don't have a org set, let the child know we are no longer waiting
    if (haveSetOrg === false) {
      this.setState({
        employerId: 'none',
        waitForEmployerId: false
      });
    }
  }

  updateSubscription(planId) {
    this.setState({
      selectedPlanId: planId
    })
  }

  proceedAfterUpdatingSubscription() {
    if (!this.state.selectedPlanId) {
      this.setState({
        alert: (
          <SweetAlert
            style={{ display: "block", marginTop: "-100px" }}
            title="select a subscription"
            onConfirm={() => this.hideAlert()}
            confirmBtnCssClass={
              this.props.classes.button + " " + this.props.classes.success
            }
            confirmBtnText="Okay"
            id="selectSubscriptionAlert"
          >
            Please select a subscription before proceeding.
          </SweetAlert>)
      });
    } else {
      sessionStorage.setItem('planId', this.state.selectedPlanId);
      window.location.reload();
    }
  }

  hideAlert() {
    this.setState({
      alert: null
    });
  }
  render() {
    const { classes } = this.props;
    return (
      <div>
        {this.state.alert}
        <GridContainer>
          <GridItem xs={12} sm={12} style={this.state.showPreLoginHeaderAndFooter ? {} : { display: 'none' }} >
            <PreLoginHeader />
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <ConditionalWrapper
              condition={this.state.useCardWrapper}
              wrapper={children => <Card>{children}</Card>}
              altWrapper={children => <h4 className={classes.infoText} justify="center" >{children}</h4>}
            >
              <Subscriptions
                userId={this.state.userId}
                editByOrg={this.state.editByOrg}
                viewType={this.state.viewType}
                cardTitle={this.state.cardTitle}
                cardSubtitle={this.state.cardSubtitle}
                showCardIcon={this.state.showCardIcon}
                planNotYetSelected={this.state.planNotYetSelected}
                onPlanUpdateSetPlanId={this.updateSubscription.bind(this)}
                employerId={this.state.employerId}
                waitForEmployerId={this.state.waitForEmployerId}
              />
            </ConditionalWrapper>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} style={this.state.showPreLoginHeaderAndFooter ? {} : { display: 'none' }} >
            <Button
              className={classes.proceedButton}
              onClick={() => this.proceedAfterUpdatingSubscription()}
              round
              color="cirrusBlue"
              id="proceedAfterUpdatingSubscriptionButton"
            >
              continue
            </Button>
          </GridItem>
        </GridContainer>
      </div>
    )

  }


}

export default withStyles(style)(SubscriptionsPage);
